export default __webpack_public_path__ + "static/media/WelcomeRight.ae53f498.png";